
<div (click)="close($event)">

  <mat-icon class="icon-err" color="warn">error</mat-icon>

  <span [innerHTML]="text.message"></span>

</div>
